import { render, staticRenderFns } from "./Examen2.vue?vue&type=template&id=e0c13436"
import script from "./Examen2.vue?vue&type=script&lang=js"
export * from "./Examen2.vue?vue&type=script&lang=js"
import style0 from "./Examen2.vue?vue&type=style&index=0&id=e0c13436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports